export enum ReportStatus {
  NewStatus = 0,
  AssignedStatus = 1,
  ClosedStatus = 2,
  DoneStatus = 3,
}